import React from 'react';
import PropTypes from 'prop-types';
import { Button } from 'reactstrap';
import moment from 'moment';
import { sortBy } from 'lodash';
import SlidingPane from 'react-sliding-pane';
import 'react-sliding-pane/dist/react-sliding-pane.css';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import LoadingOverlay from 'react-loading-overlay';
import ConfirmModal from '../../components/CommonModals/ConfirmModal';
import axios from 'axios';
import { API_HOST, HTTP_PROTOCOL } from '../../config';
import { connect } from 'react-redux';
import { getPricingInfos } from '../../state/services/bookingService';

class FPPricingSlider extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            currentTab: 0, // 0: All Pricing, 1: Errors, 2: Surcharges
            onLoadedError: false,
            selectedSurcharge: null,      
            selectedSurchargeFor: 'client',     // 'dme' or 'client'
            selectedQuote: null,      
            isShowDeleteQuoteConfirmModal: false,
            isShowCustomerFreightProviderForm: false,
            isShowLHFM: false,
            formInputs: {
                fee: 0,
                mu_percentage_fuel_levy: 0,
                client_mu_1_minimum_values: 0,
                packed_status: 'original',
            },
            quotes : null,
            isRefreshing: false,
        };
        this.toggleDeleteQuoteConfirmModal = this.toggleDeleteQuoteConfirmModal.bind(this);
        this.toggleCustomerFreightProviderForm = this.toggleCustomerFreightProviderForm.bind(this);
        this.submitHandler = this.submitHandler.bind(this);
    }

    static propTypes = {
        isOpen: PropTypes.bool.isRequired,
        toggleSlider: PropTypes.func.isRequired,
        pricings: PropTypes.array.isRequired,
        onSelectPricing: PropTypes.func.isRequired,
        clientname: PropTypes.string.isRequired,
        isLoading: PropTypes.bool.isRequired,
        isBooked: PropTypes.bool.isRequired,
        onLoadPricingErrors: PropTypes.func.isRequired,
        errors: PropTypes.array.isRequired,
        x_manual_booked_flag: PropTypes.bool,
        api_booking_quote_id: PropTypes.number,
        clientSalesTotal: PropTypes.number,
        is_quote_locked: PropTypes.bool,
        booking: PropTypes.array,
        bookingLabels: PropTypes.object,
        getPricingInfos: PropTypes.func.isRequired,
        isGWSubClient: PropTypes.bool,
    };

    notify = (text) => toast(text);

    componentDidUpdate(prevProps) { 
        if (((this.props.booking && this.props.booking.kf_client_id == '15732b05-d597-419b-8dc5-90e633d9a7e9') || 
        (this.props.bookingLabels && this.props.bookingLabels.b_client_name.toLowerCase().includes('ariston'))) && prevProps.booking !== this.props.booking ) {
            this.getBidQuotes();
        }
    }

    getBidQuotes() {
        this.setState({isRefreshing: true});
        const token = localStorage.getItem('token');
        const options = {
            method: 'get',
            url: `${HTTP_PROTOCOL}://${API_HOST}/fp/get_bid_quotes/?booking_id=${this.props.booking? this.props.booking.id : null }&pk_booking_id=${this.props.booking? this.props.booking.pk_booking_id :this.props.bookingLabels.id }`, // 330522
            headers: {'Authorization': 'JWT ' + token },
        };
        axios(options)
            .then((res) => {
                this.setState({quotes: res.data.quotes, isRefreshing: false});
            })
            .catch((error) => {
                this.notify('Failed: ' + error);
                this.setState({isRefreshing: false});

            });
    }

    UNSAFE_componentWillReceiveProps(newProps) {
        const {isOpen} = newProps;
        if (!isOpen) {
            this.setState({onLoadedError: false, isShowCustomerFreightProviderForm: false});
            document.body.style.overflow = '';
        } else {
            document.body.style.overflow = 'hidden';
        }
    }

    onSelectLowest() {
        const {pricings, x_manual_booked_flag} = this.props;

        if (x_manual_booked_flag) {
            this.notify('Cannot select a FC, this booking is manually booked');
        } else {
            const sortedpricings = sortBy(pricings, ['client_mu_1_minimum_values']);
            this.props.onSelectPricing(sortedpricings[0], this.props.is_quote_locked);
        }
    }

    onSelectFastest() {
        const {pricings, x_manual_booked_flag} = this.props;

        if (x_manual_booked_flag) {
            this.notify('Cannot select a FC, this booking is manually booked');
        } else {
            const sortedpricings = sortBy(pricings, [function(o) { return o.eta_de_by; }]);
            this.props.onSelectPricing(sortedpricings[0], this.props.is_quote_locked);
        }
    }

    onClickSelect(pricing, isLocking) {
        const {x_manual_booked_flag, clientname, booking} = this.props;

        if (x_manual_booked_flag && clientname !== 'dme') {
            this.notify('Cannot select a FC, this booking is manually booked');
        } else if (clientname == 'Aberdeen Paper' && pricing.freight_provider != 'Direct Freight') {
            this.notify('Cannot select this FP, only Direct Freight is available for Aberdeen Paper');
        } else {
            if (booking.vx_freight_provider && (booking.vx_freight_provider !== pricing.freight_provider || booking.vx_serviceName !== pricing.service_name)) {
                alert('Att: You have selected an option that requires a new label, which we already created for you. Please remember to print and use these new labels and replace existing adhered labels if necessary');
                pricing['is_quote_updated'] = true;
            }
            this.props.onSelectPricing(pricing, isLocking);
        }
    }

    onLockPricing(pricing, api_booking_quote_id, is_quote_locked) {
        if (!is_quote_locked) {
            this.onClickSelect(pricing, true);
        } else {
            if (pricing.id === api_booking_quote_id) {
                this.onClickSelect(pricing, !is_quote_locked);
            } else {
                this.onClickSelect(pricing, is_quote_locked);
            }
        }
    }

    onSelectTab(value) {
        this.setState({currentTab: value});

        if (value === 1 && !this.state.onLoadedError) {
            this.props.onLoadPricingErrors();
            this.setState({onLoadedError: true});
        }
    }

    onClickSurcharge(pricing, dmeOrClient='client') {
        this.setState({currentTab: 2, selectedSurcharge: pricing.surcharges, selectedSurchargeFor: dmeOrClient});
    }

    toggleCustomerFreightProviderForm() {
        this.setState(prevState => ({isShowCustomerFreightProviderForm: !prevState.isShowCustomerFreightProviderForm}));
    }

    toggleDeleteQuoteConfirmModal() {
        this.setState(prevState => ({isShowDeleteQuoteConfirmModal: !prevState.isShowDeleteQuoteConfirmModal}));
    }

    onClickCustomerFreightProvider(quote) {
        const { booking } = this.props;
        let formInputs= {
            fee: 0,
            etd: 3,
            mu_percentage_fuel_levy: 0,
            client_mu_1_minimum_values: 0,
            packed_status: 'original',
            fk_booking_id: booking.pk_booking_id,
            fk_client_id: booking.kf_client_id
        };
        if (quote) {
            formInputs = {
                quote_id: quote.id,
                freight_provider: quote.freight_provider,
                service_name: quote.service_name,
                fee: quote.cost_dollar,
                etd: quote.etd,
                mu_percentage_fuel_levy: quote.mu_percentage_fuel_levy,
                client_mu_1_minimum_values:  Number(quote.cost_dollar * (1 + Number(quote.mu_percentage_fuel_levy))).toFixed(3),                    
                packed_status: quote.packed_status
            };
        }
        this.setState({ formInputs });
        this.setState({ selectedQuote: quote });
        this.toggleCustomerFreightProviderForm();
    }

    submitHandler(e) {
        e.preventDefault();
        const { formInputs, selectedQuote } = this.state;
        const token = localStorage.getItem('token');
        
        const options = {
            method: selectedQuote ? 'put' : 'post',
            url: `${HTTP_PROTOCOL}://${API_HOST}/pricing/${selectedQuote ? 'edit' : 'add'}/`,
            headers: {'Authorization': 'JWT ' + token },
            data: { ...formInputs }
        };
        axios(options)
            .then(() => {
                this.notify('Successfully Done!');
                this.toggleCustomerFreightProviderForm();
                this.props.getPricingInfos(this.props.booking.id);
            })
            .catch((error) => {
                this.notify('Failed: ' + error);
            });

    }

    onClickDeleteQuote(quote) {
        this.setState({selectedQuote: quote});
        this.toggleDeleteQuoteConfirmModal();
    }

    onDeleteQuote() {
        const { selectedQuote } = this.state;
        const options = {
            method: 'delete',
            url: `${HTTP_PROTOCOL}://${API_HOST}/pricing/${selectedQuote.id}/delete/`,
        };
        axios(options)
            .then(() => {
                this.notify('Successfully Done!');
                this.props.getPricingInfos(this.props.booking.id);
            })
            .catch((error) => {
                this.notify('Failed: ' + error);
            });
        this.toggleDeleteQuoteConfirmModal();
    }
    
    onInputChange(event) {
        const { formInputs } = this.state;
        const target = event.target;
        const value = target.value;
        const name = target.name;

        formInputs[name] = value;
        if (name === 'etd') {
            if ((value.length - value.indexOf('.')) > 1) {
                formInputs[name] = Number(value).toFixed(1);
            }
        }
        if (name === 'fee' || name === 'mu_percentage_fuel_levy') {
            if ((value.length - value.indexOf('.')) > 3) {
                formInputs[name] = Number(value).toFixed(3);
            }
            formInputs['client_mu_1_minimum_values'] = Number(formInputs['fee'] * (1 + Number(formInputs['mu_percentage_fuel_levy']))).toFixed(3); 
        }
        this.setState({formInputs});
    }

    onClickShowLHFM() {
        const { clientname } = this.props;
        const { isShowLHFM } = this.state;

        if (clientname !== 'dme') {
            this.notify('It is DME user feature.');
            return;
        }

        this.setState({ isShowLHFM: !isShowLHFM });
    }

    getLHFMTr(selectedPricing, index, src) {
        const { clientname, pricings, clientSalesTotal, isGWSubClient } = this.props;
        let pricing;

        if (src === 'lh') {
            const lhID = selectedPricing.notes.split('+')[0];
            pricing = pricings.find(iter => iter['id'].toString() === lhID);
        } else {
            const fmID = selectedPricing.notes.split('+')[1];
            pricing = pricings.find(iter => iter['id'].toString() === fmID);
        }

        let clientSalesTotal5Percent = 0;

        if (clientSalesTotal)
            clientSalesTotal5Percent = clientSalesTotal * 0.05;

        let clientCustomerMarkup = (pricing.client_customer_mark_up * 100).toFixed(2);
        let clientCustomerPrice = pricing.total_dollar;

        if (pricing.parent_markup_percent) {
            clientCustomerPrice *= (1 + pricing.parent_markup_percent);
        }

        clientCustomerPrice *= (1 + pricing.client_customer_mark_up);
        clientCustomerPrice = clientCustomerPrice.toFixed(2);

        if (clientCustomerPrice < clientSalesTotal5Percent) {
            clientCustomerMarkup = 0;
            clientCustomerPrice = clientSalesTotal5Percent;
        }

        return (
            <tr key={index + selectedPricing['id'].toString() + src}>
                <td>{index + 1}.{src === 'lh' ? '1' : '2'}</td>
                <td>{pricing.freight_provider}({pricing.account_code})</td>
                <td>{src === 'lh' ? 'Linehaul' : 'Final Mile'}</td>
                <td>{pricing.is_from_api ? 'Yes' : ''}</td>
                <td>{pricing.etd}</td>
                {clientname === 'dme' && <td className="text-right">${pricing.fee.toFixed(2)}</td>}
                {clientname === 'dme' &&
                    <td className="text-right">
                        ${pricing.surcharge_total.toFixed(2)}
                            &nbsp;&nbsp;&nbsp;
                        {pricing.surcharge_total ? <i className="fa fa-dollar-sign" onClick={() => this.onClickSurcharge(pricing, 'dme')}></i> : null}
                    </td>
                }
                {clientname === 'dme' && <td className="text-right">{(pricing.mu_percentage_fuel_levy * 100).toFixed(2)}%</td>}
                {clientname === 'dme' && <td className="text-right">${pricing.fuel_levy_base.toFixed(2)}</td>}
                {clientname === 'dme' &&<td className="text-right">${(pricing.fee + pricing.fuel_levy_base + pricing.surcharge_total).toFixed(2)}</td>}
                {clientname === 'dme' && <td className="text-right">{(pricing.client_mark_up_percent * 100).toFixed(2)}%</td>}
                <td className="text-right">${pricing.cost_dollar.toFixed(2)}</td>
                <td className="text-right">{(pricing.mu_percentage_fuel_levy * 100).toFixed(2)}%</td>
                <td className="text-right">${pricing.fuel_levy_base_cl.toFixed(2)}</td>
                <td className="text-right nowrap">
                    {pricing.surcharge_total_cl ? ('$' + pricing.surcharge_total_cl.toFixed(2)) : null}
                    &nbsp;&nbsp;&nbsp;
                    {pricing.surcharge_total_cl ? <i className="fa fa-dollar-sign" onClick={() => this.onClickSurcharge(pricing, 'client')}></i> : null}
                </td>
                <td className="text-right">
                    ${pricing.total_dollar.toFixed(3)}
                    {(clientname === 'dme' && pricing.pt_old_value) ? <br /> : ''}
                    {(clientname === 'dme' && pricing.pt_old_value) ? <span className="c-red">(${pricing.pt_old_value.toFixed(3)})</span> : ''}
                </td>
                {((clientname === 'dme' || clientname === 'Gebrüder Weiss') && isGWSubClient) &&
                    <td className="text-right">
                        {(pricing.parent_markup_percent * 100).toFixed(2)}%
                    </td>
                }
                {((clientname === 'dme' || clientname === 'Gebrüder Weiss') && isGWSubClient) &&
                    <td className="text-right">
                        {(pricing.client_mu_1_minimum_values * (1 + pricing.parent_markup_percent)).toFixed(3)}
                    </td>
                }
                <td className="text-right">{clientCustomerMarkup}%</td>
                <td className="text-right">${clientCustomerPrice}</td>
                <td>
                </td>
                <td>
                </td>
                <td>
                </td>
            </tr>
        );
    }

    render() {
        const {
            isOpen, clientname, isBooked, api_booking_quote_id,
            clientSalesTotal, is_quote_locked, pricings, errors,
            isGWSubClient
        } = this.props;
        const {
            currentTab, selectedSurcharge, selectedSurchargeFor,
            formInputs, isShowCustomerFreightProviderForm, isShowLHFM
        } = this.state;
        const isLoggedIn = localStorage.getItem('isLoggedIn');
        let surchargeList = null;
        let pricingTables = [];

        const LHFMquotes = pricings.filter(pricing => (pricing.notes || '').indexOf('+') != -1);
        const hasLHFMquote = LHFMquotes.length > 0;
        const otb_obj = {};

        for (let pricing of pricings) {
            if (!otb_obj.hasOwnProperty(pricing.freight_provider)) {
                const key = `${pricing.freight_provider}|${pricing.service_desc}`;
                const random = Math.floor(Math.random() * (99 - 85 + 1)) + 85;
                otb_obj[key] = random;
            }
        }

        for (let packed_status of ['original', 'auto', 'manual', 'scanned']) {
            let pricingList = [];
            let includeLHFMquote = false;
            pricings
                .filter(pricing => pricing.packed_status === packed_status)
                .sort((a, b) =>  a.client_mu_1_minimum_values - b.client_mu_1_minimum_values)
                // .filter(pricing => pricing.linehaul_quote === null) // LH + FM
                // .filter(pricing => pricing.linehaul_fp === null)    // LH + FM
                .map((pricing, index) => {
                    if (clientname !== 'dme' && includeLHFMquote)
                        return;

                    const key = `${pricing.freight_provider}|${pricing.service_desc}`;
                    let clientSalesTotal5Percent = 0;

                    if (clientSalesTotal)
                        clientSalesTotal5Percent = clientSalesTotal * 0.05;

                    let clientCustomerMarkup = (pricing.client_customer_mark_up * 100).toFixed(2);
                    let clientCustomerPrice = pricing.total_dollar;

                    if (pricing.parent_markup_percent) {
                        clientCustomerPrice *= (1 + pricing.parent_markup_percent);
                    }

                    clientCustomerPrice *= (1 + pricing.client_customer_mark_up);
                    clientCustomerPrice = clientCustomerPrice.toFixed(2);

                    if (clientCustomerPrice < clientSalesTotal5Percent) {
                        clientCustomerMarkup = 0;
                        clientCustomerPrice = clientSalesTotal5Percent;
                    }

                    let tr = (
                        <tr key={index} className={api_booking_quote_id === pricing.id ? 'selected' : '' }>
                            <td>{index + 1}</td>
                            <td onClick={() => this.onClickFP()}>{pricing.freight_provider}({pricing.account_code})</td>
                            <td>{pricing.vehicle_name ? `${pricing.service_desc} (${pricing.vehicle_name})` : pricing.service_desc}</td>
                            <td>{pricing.is_from_api ? 'Yes' : ''}</td>
                            <td>{pricing.etd}</td>
                            <td>{otb_obj[key]}%</td>
                            {clientname === 'dme' &&
                                <td className="text-right">
                                    ${pricing.fee.toFixed(2)}
                                    {pricing.pt_old_value ? <br /> : ''}
                                    {pricing.pt_old_fee ? <span className="c-red">(${pricing.pt_old_fee.toFixed(3)})</span> : ''}
                                </td>
                            }
                            {clientname === 'dme' &&
                                <td className="text-right">
                                    ${pricing.surcharge_total.toFixed(2)}
                                        &nbsp;&nbsp;&nbsp;
                                    {pricing.surcharge_total ? <i className="fa fa-dollar-sign" onClick={() => this.onClickSurcharge(pricing, 'dme')}></i> : null}
                                </td>
                            }
                            {clientname === 'dme' && <td className="text-right">{(pricing.mu_percentage_fuel_levy * 100).toFixed(2)}%</td>}
                            {clientname === 'dme' &&
                                <td className="text-right">
                                    ${pricing.fuel_levy_base.toFixed(2)}
                                    {pricing.pt_old_value ? <br /> : ''}
                                    {pricing.pt_old_fl_base ? <span className="c-red">(${pricing.pt_old_fl_base.toFixed(3)})</span> : ''}
                                </td>
                            }
                            {clientname === 'dme' &&<td className="text-right">${(pricing.fee + pricing.fuel_levy_base + pricing.surcharge_total).toFixed(2)}</td>}
                            {clientname === 'dme' && <td className="text-right">{(pricing.client_mark_up_percent * 100).toFixed(2)}%</td>}
                            <td className="text-right">
                                ${pricing.cost_dollar.toFixed(2)}
                                {(clientname === 'dme' && pricing.pt_old_value) ? <br /> : ''}
                                {(clientname === 'dme' && pricing.pt_old_value) ? <span className="c-red">(${pricing.cost_dollar_old.toFixed(3)})</span> : ''}
                            </td>
                            <td className="text-right">{(pricing.mu_percentage_fuel_levy * 100).toFixed(2)}%</td>
                            <td className="text-right">
                                ${pricing.fuel_levy_base_cl.toFixed(2)}
                                {(clientname === 'dme' && pricing.pt_old_value) ? <br /> : ''}
                                {(clientname === 'dme' && pricing.pt_old_value) ? <span className="c-red">(${pricing.fuel_levy_base_cl_old.toFixed(3)})</span> : ''}
                            </td>
                            <td className="text-right nowrap">
                                {pricing.surcharge_total_cl ? ('$' + pricing.surcharge_total_cl.toFixed(2)) : null}
                                &nbsp;&nbsp;&nbsp;
                                {pricing.surcharge_total_cl ? <i className="fa fa-dollar-sign" onClick={() => this.onClickSurcharge(pricing, 'client')}></i> : null}
                            </td>
                            <td className="text-right nowrap">
                                {pricing.insurance ? ('$' + pricing.insurance.sell_price.toFixed(2)) : null}
                            </td>
                            <td className="text-right">
                                ${pricing.total_dollar.toFixed(3)}
                                {(clientname === 'dme' && pricing.pt_old_value) ? <br /> : ''}
                                {(clientname === 'dme' && pricing.pt_old_value) ? <span className="c-red">(${pricing.pt_old_value.toFixed(3)})</span> : ''}
                            </td>
                            {(clientname === 'dme' || clientname === 'Gebrüder Weiss') &&
                                <td className="text-right">
                                    {(pricing.parent_markup_percent * 100).toFixed(2)}%
                                </td>
                            }
                            {(clientname === 'dme' || clientname === 'Gebrüder Weiss') &&
                                <td className="text-right">
                                    {(pricing.client_mu_1_minimum_values * (1 + pricing.parent_markup_percent)).toFixed(3)}
                                </td>
                            }
                            <td className="text-right">{clientCustomerMarkup}%</td>
                            <td className="text-right">${clientCustomerPrice}</td>
                            <td className={pricing.is_deliverable ? 'text-right bg-lightgreen' : 'text-right'}>
                                {pricing && pricing.eta_de_by ? moment(pricing.eta_de_by).format('DD/MM/YYYY') : ''}
                            </td>
                            <td className={pricing.provider === 'Customer' ? 'customer-select' : 'select'}>
                                <div>
                                    <Button
                                        className="btn-sm btn-icon"
                                        color={(api_booking_quote_id === pricing.id || (isBooked && clientname !== 'dme')) ? 'success' : 'primary'}
                                        disabled={(api_booking_quote_id === pricing.id || (isBooked && clientname !== 'dme'))}
                                        onClick={() => this.onClickSelect(pricing)}
                                    >
                                        <i className='fa fa-check'/>
                                    </Button>
                                    {pricing.provider === 'Customer' && 
                                        <Button
                                            className='btn-sm btn-icon'
                                            color='primary'
                                            disabled={isLoggedIn === 'true' ? null : 'disabled'}
                                            onClick={() => this.onClickCustomerFreightProvider(pricing)}
                                        >
                                            <i className='fa fa-pencil-alt'/>
                                        </Button>
                                    }
                                    {pricing.provider === 'Customer' && 
                                        <Button
                                            className='btn-sm btn-icon'
                                            color='danger'
                                            disabled={api_booking_quote_id !== pricing.cost_id && isLoggedIn === 'true' ? null : 'disabled'}
                                            onClick={() => this.onClickDeleteQuote(pricing)}
                                        >
                                            <i className='fa fa-trash'/>
                                        </Button>
                                    }
                                </div>
                            </td>
                            <td>
                                <input
                                    type='checkbox'
                                    color={api_booking_quote_id === pricing.id ? 'success' : 'primary'}
                                    checked={api_booking_quote_id === pricing.id && is_quote_locked}
                                    onClick={() => this.onLockPricing(pricing, api_booking_quote_id, is_quote_locked)}
                                />
                            </td>
                        </tr>
                    );
                    pricingList.push(tr);

                    if ((pricing.notes || '').indexOf('+') != -1) {
                        includeLHFMquote = true;
                        if (isShowLHFM) {
                            pricingList.push(this.getLHFMTr(pricing, index, 'lh'));
                            pricingList.push(this.getLHFMTr(pricing, index, 'fm'));
                        }
                    }
                });
            const pricingTable = pricingList.length > 0 ? (
                <table className="table table-hover table-bordered sortable fixed_headers">
                    <thead>
                        <tr>
                            <th className="nowrap" scope="col" nowrap="true"><p>No</p></th>
                            <th className="nowrap" scope="col" nowrap="true"><p>Transporter</p></th>
                            <th className="nowrap" scope="col" nowrap="true"><p>Service (Vehicle)</p></th>
                            <th className="nowrap" scope="col" nowrap="true"><p>API?</p></th>
                            <th className="nowrap" scope="col" nowrap="true"><p>Transport Days (working)</p></th>
                            <th className="nowrap" scope="col" nowrap="true"><p>On Time Probability</p></th>
                            {clientname === 'dme' && <th className="nowrap" scope="col" nowrap="true"><p>FP Cost (Ex GST)</p></th>}
                            {clientname === 'dme' && <th className="nowrap" scope="col" nowrap="true"><p>FP Extra`s (Ex GST)</p></th>}
                            {clientname === 'dme' && <th className="nowrap" scope="col" nowrap="true"><p>FP Fuel Levy %</p></th>}
                            {clientname === 'dme' && <th className="nowrap" scope="col" nowrap="true"><p>FP Fuel Levy Amount</p></th>}
                            {clientname === 'dme' && <th className="nowrap" scope="col" nowrap="true"><p>FP Total Cost (Ex GST)</p></th>}
                            {clientname === 'dme' && <th className="nowrap" scope="col" nowrap="true"><p>DME Client Markup %</p></th>}
                            <th className="nowrap" scope="col" nowrap="true"><p>Cust Cost $</p></th>
                            <th className="nowrap" scope="col" nowrap="true"><p>FP Fuel Levy %</p></th>
                            <th className="nowrap" scope="col" nowrap="true"><p>FP Fuel Levy Amount</p></th>
                            <th className="nowrap" scope="col" nowrap="true"><p>Extra $</p></th>
                            <th className="nowrap" scope="col" nowrap="true"><p>Insurance $</p></th>
                            <th className="nowrap" scope="col" nowrap="true"><p>Total $ (Ex. GST)</p></th>
                            {((clientname === 'dme' || clientname === 'Gebrüder Weiss') && isGWSubClient) &&
                                <th className="nowrap" scope="col" nowrap="true"><p>GW Customer Markup %</p></th>}
                            {((clientname === 'dme' || clientname === 'Gebrüder Weiss') && isGWSubClient) &&
                                <th className="nowrap" scope="col" nowrap="true"><p>GW Sell Price</p></th>}
                            <th className="nowrap" scope="col" nowrap="true"><p>Client Customer Markup %</p></th>
                            <th className="nowrap" scope="col" nowrap="true"><p>Cust Sell $</p></th>
                            <th className="nowrap" scope="col" nowrap="true"><p>ETA</p></th>
                            <th className="nowrap" scope="col" nowrap="true"><p>Action</p></th>
                            <th className="nowrap" scope="col" nowrap="true"><p>Lock</p></th>
                        </tr>
                    </thead>
                    <tbody>
                        { pricingList }
                    </tbody>
                </table>
            ) : 'No results';
            pricingTables.push(pricingTable);
        }

        (errors || []).sort((a, b) =>  {
            if (a.fp_name > b.fp_name) return 1;
            else if (a.fp_name < b.fp_name) return -1;
            else return 0;
        });

        const errorsList = (errors || []).map((error, index) => {
            return (
                <tr key={index}>
                    <td>{index + 1}</td>
                    <td>{error.fp_name}</td>
                    <td>{error.accountCode}</td>
                    <td>{error.error_code}</td>
                    <td>{error.error_description}</td>
                </tr>
            );
        });

        if (selectedSurcharge) {
            surchargeList = selectedSurcharge
                .filter(surcharge => clientname === 'dme' || surcharge.visible)
                .map((surcharge, index) => {
                    return (
                        <p className="surcharge" key={index}>
                            <strong>Name:</strong> {surcharge['name']}<br />
                            <strong>Description:</strong> {surcharge['description']}<br />
                            <strong>Amount:</strong> {selectedSurchargeFor === 'dme' ? surcharge['amount'] : surcharge['amount_cl']}<br />
                            <strong>Qty:</strong> {surcharge['qty'] || 1}<br />
                            <strong>Manually added?:</strong> {surcharge['is_manually_entered'] ? 'Yes' : 'No'}<br />
                            <hr />
                        </p>
                    );
                });
        }

        return(
            <SlidingPane
                className='fp-pricing-pan'
                isOpen={isOpen}
                title='Freight Provider Pricing Panel'
                subtitle='List View'
                onRequestClose={this.props.toggleSlider}
            >
                <div className="slider-content">
                    <div id="headr" className="col-md-12 mb-5">
                        <div className="col-md-7 col-sm-12 col-lg-8 col-xs-12">
                            <ul className="nav nav-tabs">
                                <li className={currentTab == 0 ? 'active' : ''}>
                                    <a onClick={() => this.onSelectTab(0)}>All Pricing</a>
                                </li>
                                <li className={currentTab == 1 ? 'active' : ''}>
                                    <a onClick={() => this.onSelectTab(1)}>Errors</a>
                                </li>
                                <li className={currentTab == 2 ? 'active' : ''}>
                                    <a onClick={() => this.onSelectTab(2)}>Surcharges</a>
                                </li>
                                { 
                                    ((this.props.booking && this.props.booking.kf_client_id == '15732b05-d597-419b-8dc5-90e633d9a7e9') || 
                                    (this.props.bookingLabels && this.props.bookingLabels.b_client_name.toLowerCase().includes('ariston'))) && (  // if Ariston booking
                                    // (
                                        <li className={currentTab == 3 ? 'active' : ''}>
                                            <a onClick={() => this.onSelectTab(3)}>FP Quote Requests</a>
                                        </li>
                                    )
                                }
                            </ul>
                        </div>
                    </div>
                    <div className="table-view">
                        <LoadingOverlay
                            active={this.props.isLoading || this.state.isRefreshing}
                            spinner
                            text='Loading...'
                            styles={{
                                spinner: (base) => ({
                                    ...base,
                                    '& svg circle': {
                                        stroke: '#048abb'
                                    }
                                })
                            }}
                        >
                            {currentTab === 0 ?
                                <Button
                                    className="lowest"
                                    color="primary"
                                    disabled={(pricings.length === 0 || isBooked || clientname == 'Aberdeen Paper')}
                                    onClick={() => this.onSelectLowest('lowest')}
                                >
                                    Select lowest price
                                </Button>
                                :
                                null
                            }
                            {currentTab === 0 ?
                                <Button
                                    className="fastest"
                                    color="primary"
                                    disabled={(pricings.length === 0 || isBooked || clientname == 'Aberdeen Paper')}
                                    onClick={() => this.onSelectFastest('fastest')}
                                >
                                    Select fastest price
                                </Button>
                                :
                                null
                            }
                            {currentTab === 0 ?
                                <Button
                                    className="fastest"
                                    color="primary"
                                    onClick={() => this.onClickCustomerFreightProvider(null)}
                                    disabled={isLoggedIn === 'true' ? null : 'disabled'}
                                >
                                    Customer Freight Provider
                                </Button>
                                :
                                null
                            }
                            {(currentTab === 0 && clientname === 'dme') ?
                                <Button
                                    className="fastest"
                                    color="success"
                                    onClick={() => this.onClickShowLHFM()}
                                    disabled={!hasLHFMquote}
                                >
                                    {!isShowLHFM ? 'Show Linehaul Info' : 'Hide Linehaul Info'}
                                </Button>
                                :
                                null
                            }
                            {currentTab === 0 && isShowCustomerFreightProviderForm ? (
                                <div className='customer-freight-provider-slider '>
                                    <form onSubmit={this.submitHandler}>
                                        <label>
                                            <p>Freight Provider</p>
                                            <input
                                                className="form-control"
                                                type="text"
                                                name="freight_provider"
                                                value={formInputs['freight_provider']}
                                                required
                                                onChange={(e) => this.onInputChange(e)}
                                            />
                                        </label>
                                        <label>
                                            <p>Service Name</p>
                                            <input
                                                className="form-control"
                                                type="text"
                                                name="service_name"
                                                value={formInputs['service_name']}
                                                onChange={(e) => this.onInputChange(e)}
                                            />
                                        </label>
                                        <label>
                                            <p>Estimated days</p>
                                            <input 
                                                className="form-control"
                                                required
                                                step="0.1"
                                                type="number"
                                                name="etd"
                                                value={formInputs['etd']}
                                                onChange={(e) => this.onInputChange(e)}
                                            />
                                        </label>
                                        <label>
                                            <p>Price</p>
                                            <input 
                                                className="form-control"
                                                required
                                                step="0.01"
                                                type="number"
                                                name="fee"
                                                value={formInputs['fee']}
                                                onChange={(e) => this.onInputChange(e)}
                                            />
                                        </label>
                                        <label>
                                            <p>Fuel Levy Percent</p>
                                            <input 
                                                className="form-control"
                                                required
                                                step="0.01"
                                                type="number"
                                                min={0}
                                                max={1}
                                                name="mu_percentage_fuel_levy"
                                                value={formInputs['mu_percentage_fuel_levy']}
                                                onChange={(e) => this.onInputChange(e)}
                                            />
                                        </label>
                                        <label>
                                            <p>Total Cost inc. Fuel ex GST</p>
                                            <input 
                                                className="form-control"
                                                required
                                                disabled
                                                step="0.01"
                                                type="number"
                                                name="client_mu_1_minimum_values"
                                                value={formInputs['client_mu_1_minimum_values']}
                                            />
                                        </label>
                                        <label>
                                            <p>Packed Status</p>
                                            <select
                                                className="form-control"
                                                name="packed_status"
                                                value={formInputs['packed_status']}
                                                onChange={(e) => this.onInputChange(e)}
                                            >
                                                <option value='original'>Send As</option>
                                                <option value='auto'>Auto Repack</option>
                                                <option value='manual'>Manual Repack</option>
                                                <option value='scanned'>Actual Packed / Packing Scans</option>
                                            </select>
                                        </label>
                                        <label>
                                            <Button type="submit primary" color="primary">Submit</Button>
                                            <Button color="danger" onClick={() => this.toggleCustomerFreightProviderForm()}>Cancel</Button>
                                        </label>
                                    </form>
                                </div>
                            ) : (
                                currentTab !== 3 && (
                                    <div>
                                        {currentTab === 0 && clientSalesTotal &&
                                            <h3><strong>Sales Total Value:</strong> {clientSalesTotal}</h3>
                                        }
                                        {pricingTables.map((pricingTable, i) =>
                                            <div key={i} className="pricing-table">
                                                { i === 0 && <h3>Send As</h3> }
                                                { i === 1 && <h3>Auto Repacked</h3> }
                                                { i === 2 && <h3>Manual Repacked</h3> }
                                                { i === 3 && <h3>Actual Packed / Packing Scans</h3> }
                                                <div className="table-wrapper">{pricingTable}</div>
                                            </div>
                                        )}
                                    </div>
                                )
                            )}
                            {currentTab === 1 ?
                                <table className="table table-hover table-bordered table-striped sortable fixed_headers">
                                    <thead>
                                        <tr>
                                            <th className="" scope="col" nowrap="true"><p>No</p></th>
                                            <th className="" scope="col" nowrap="true"><p>Freight Provider</p></th>
                                            <th className="" scope="col" nowrap="true"><p>Account Code</p></th>
                                            <th className="" scope="col" nowrap="true"><p>Error Code</p></th>
                                            <th className="" scope="col" nowrap="true"><p>Error Description</p></th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        { errorsList }
                                    </tbody>
                                </table>
                                :
                                null
                            }
                            {currentTab === 2 ?
                                surchargeList ?
                                    <div>{surchargeList}</div>
                                    :
                                    <p>Please select surcharge $ sign on [ALL PRICING] tab.</p>
                                : null
                            }
                            {currentTab === 3 ?
                                api_booking_quote_id && (!this.state.quotes || this.state.quotes.length === 0) ? (
                                    <h3>A DME booking was made before quote request were sent, thus no quote request was sent to your Freight Providers</h3>
                                ) : this.state.quotes && this.state.quotes.length > 0 ?
                                    (
                                        <div>                                       
                                            <table className="table table-hover table-bordered table-striped sortable fixed_headers">
                                                <thead>
                                                    <tr>
                                                        <th className="" scope="col" nowrap="true"><p>No</p></th>
                                                        <th className="" scope="col" nowrap="true"><p>Freight Provider</p></th>
                                                        <th className="" scope="col" nowrap="true"><p>DE Date</p></th>
                                                        <th className="" scope="col" nowrap="true"><p>DE Time</p></th>
                                                        <th className="" scope="col" nowrap="true"><p>PU Date</p></th>
                                                        <th className="" scope="col" nowrap="true"><p>PU Time</p></th>
                                                        <th className="" scope="col" nowrap="true"><p>Quote amount</p></th>
                                                        <th className="" scope="col" nowrap="true"><p>Status</p></th>
                                                        <th className="" scope="col" nowrap="true"><p>Note from FP</p></th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {
                                                        this.state.quotes.map((item, index) => {
                                                            return (
                                                                <tr key = {index} >
                                                                    <td> { index + 1} </td>
                                                                    <td> { item.freight_provider } </td>
                                                                    <td> { item.pickup_timestamp ? moment(item.pickup_timestamp).format('DD/MM/YYYY') : '' } </td>
                                                                    <td> { item.pickup_timestamp ? moment(item.pickup_timestamp).format('HH:mm') : '' } </td>
                                                                    <td> { item.delivery_timestamp ? moment(item.delivery_timestamp).format('DD/MM/YYYY') : '' } </td>
                                                                    <td> { item.delivery_timestamp ? moment(item.delivery_timestamp).format('HH:mm') : '' } </td>
                                                                    <td> { item.amount ? 
                                                                        item.amount.toLocaleString('en-US', { 
                                                                            style: 'currency',  
                                                                            currency: 'USD', 
                                                                            minimumFractionDigits: 2,
                                                                            maximumFractionDigits: 2}) : ''} 
                                                                    </td>
                                                                    <td> { item.status }  </td>
                                                                    <td> { item.notes }  </td>
                                                                </tr> 
                                                            );
                                                        })
                                                    }
                                                </tbody>
                                            </table>
                                            <Button
                                                className="btn-sm btn-icon"
                                                style={{ width: '80px'}}
                                                color='primary'
                                                onClick={()=>{this.getBidQuotes();}}
                                            >
                                                Refresh
                                            </Button>
                                            
                                        </div>

                                    )
                                    :
                                    <h3>No Data</h3>
                                : null
                            }
                        </LoadingOverlay>
                    </div>
                </div>
                <ConfirmModal
                    isOpen={this.state.isShowDeleteQuoteConfirmModal}
                    onOk={() => this.onDeleteQuote()}
                    onCancel={() => this.toggleDeleteQuoteConfirmModal()}
                    title={'Confirmation Modal'}
                    text={'Do you really want to delete this quote?'}
                    okBtnName={'Delete'}
                />
            </SlidingPane>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        booking: state.booking.booking,
        bookingLabels: state.booking.bookingLabels
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        getPricingInfos: (id) => dispatch(getPricingInfos(id)),
    };
};

export  default connect(mapStateToProps, mapDispatchToProps)(FPPricingSlider);


// WEBPACK FOOTER //
// ./src/components/Sliders/FPPricingSlider.js